<script setup lang="ts">
import Button from 'primevue/button';

import DefaultInput from '../components/DefaultInput.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import PostalCode from '../components/PostalCode.vue';

import { useClientForm } from '../composables/useClientForm';

import { PROVINCES } from '../utils/constants';

const { form, errors, isPending, handleAddClient } = useClientForm();
</script>

<template>
  <form @submit.prevent="handleAddClient">
    <div class="mb-4 flex justify-between">
      <h2 class="font-bold text-gray-900">Dane osobowe</h2>

      <span class="text-sm text-gray-iron-700">* - pole obowiązkowe</span>
    </div>

    <div class="grid grid-cols-12 gap-6">
      <DefaultInput class="col-span-6" v-model="form.first_name" :error="errors.first_name">
        Imię*
      </DefaultInput>

      <DefaultInput class="col-span-6" v-model="form.last_name" :error="errors.last_name">
        Nazwisko*
      </DefaultInput>

      <DefaultInput class="col-span-6" v-model="form.email" :error="errors.email">
        E-mail*
      </DefaultInput>

      <DefaultInput class="col-span-6" v-model="form.phone" :error="errors.phone">
        Numer telefonu*
      </DefaultInput>

      <DefaultInput class="col-span-8" v-model="form.street" :error="errors.street">
        Adres*
      </DefaultInput>

      <DefaultInput class="col-span-2" v-model="form.house_number" :error="errors.house_number">
        Numer domu*
      </DefaultInput>

      <DefaultInput
        class="col-span-2"
        v-model="form.apartment_number"
        :error="errors.apartment_number"
      >
        Numer mieszkania
      </DefaultInput>

      <DefaultSelect
        class="col-span-2"
        v-model="form.province"
        :options="PROVINCES"
        placeholder="Wybierz"
        filter
        :error="errors.province"
      >
        Województwo*
      </DefaultSelect>

      <DefaultInput class="col-span-8" v-model="form.city" :error="errors.city">
        Miejscowość*
      </DefaultInput>

      <PostalCode class="col-span-2" v-model="form.postal_code" :error="errors.postal_code">
        Kod pocztowy*
      </PostalCode>
    </div>

    <div class="mt-4 flex items-center justify-center gap-4">
      <Button
        class="font-semibold"
        size="small"
        outlined
        type="submit"
        :disabled="Object.keys(errors).length > 0 || isPending"
      >
        Zapisz zmiany
      </Button>

      <RouterLink
        v-if="$route.name !== 'NewClientView'"
        :to="`/${$route.params.calculatorId}/client/${$route.params.clientId}/calculation/new`"
      >
        <Button class="font-semibold" size="small">
          Dodaj kalkulacje
          <i class="pi pi-arrow-right" />
        </Button>
      </RouterLink>
    </div>
  </form>
</template>
